export default __webpack_public_path__ + "static/media/logo-fix-removebg-preview.5e177f3b.png";